import { render, staticRenderFns } from "./CurrentEmployer.vue?vue&type=template&id=bf89c8e2"
import script from "./CurrentEmployer.vue?vue&type=script&lang=ts"
export * from "./CurrentEmployer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports